import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LIVESTOCK_ANIMALS_AND_EVENTS_INDEX } from '../../../router/routes';
import Title from '../../../components/common/title';
import {
  Tab,
  TabContainer,
  TabContents,
  TabLink,
  TabNavigation,
  useTab,
} from '../../../components/common/tabs/tab-container';
import ShowIfAllowed from '../../../components/common/show-if-allowed';
import AnimalsAndEventsTabKeys from './enums/animals-and-events-tab-keys';
import Animals from './animals';
import Groups from './group-animals';
import { useService } from '../../../services/services';
import { useParams } from 'react-router';
import AnimalEvents from './animal-events';

export default function AnimalsAndEvents() {
  const { t } = useTranslation();
  const { groupAnimalService } = useService();
  const transKeyPrefix = 'pages.livestock.animals_and_events.';
  const tp = useCallback((key: string) => t(transKeyPrefix.concat(key)), [t]);
  const { farmId } = useParams<{ farmId: string }>();
  const [showTab, setShowTab] = useState(false);
  const [currentTab, setTab] = useTab(LIVESTOCK_ANIMALS_AND_EVENTS_INDEX, [
    'tab',
    'farmId',
  ]);
  const [missedCountState, setMissedCountState] = useState(null);

  useEffect(() => {
    groupAnimalService.showTab(farmId).subscribe((response) => {
      setShowTab(response.show);
    });
  }, [setShowTab, farmId, groupAnimalService]);

  return (
    <div>
      <Title title={tp('title')} />

      <TabContainer
        selectedTabKey={currentTab}
        setTab={setTab}
        tabNavigation={
          <TabNavigation>
            <ShowIfAllowed ability={{ title: 'viewAny animal' }}>
              <TabLink tabKey={AnimalsAndEventsTabKeys.animals}>
                {tp('animals.title')}
              </TabLink>
            </ShowIfAllowed>
            {showTab && (
              <ShowIfAllowed ability={{ title: 'viewAny animal' }}>
                <TabLink tabKey={AnimalsAndEventsTabKeys.group_animals}>
                  {tp('group_animals.title')}
                </TabLink>
              </ShowIfAllowed>
            )}
            <ShowIfAllowed ability={{ title: 'viewAny animal_event' }}>
              <TabLink
                tabKey={AnimalsAndEventsTabKeys.events}
                count={missedCountState}
              >
                {tp('events.title')}
              </TabLink>
            </ShowIfAllowed>
          </TabNavigation>
        }
        tabContents={
          <TabContents>
            <ShowIfAllowed ability={{ title: 'viewAny animal' }}>
              <Tab tabKey={AnimalsAndEventsTabKeys.animals}>
                <Animals setMissedCountState={setMissedCountState} />
              </Tab>
            </ShowIfAllowed>
            {showTab && (
              <ShowIfAllowed ability={{ title: 'viewAny animal' }}>
                <Tab tabKey={AnimalsAndEventsTabKeys.group_animals}>
                  <Groups setMissedCountState={setMissedCountState} />
                </Tab>
              </ShowIfAllowed>
            )}
            <ShowIfAllowed ability={{ title: 'viewAny animal_event' }}>
              <Tab tabKey={AnimalsAndEventsTabKeys.events}>
                <AnimalEvents
                  setMissedCountState={setMissedCountState}
                  eventsCount={missedCountState}
                />
              </Tab>
            </ShowIfAllowed>
          </TabContents>
        }
      />
    </div>
  );
}
